export default __webpack_public_path__ + "static/media/slider3.999185c2.jpg";